import { Icon } from "@garantidos/components"

import { If } from "@mobi/components"
import { Text } from "@mobi/ds"

import useSummaryProposal from "./hooks"

import "./style.scss"

const SummaryProposal = ({ handleOpenInfo }) => {
  const { data } = useSummaryProposal()

  return (
    <div className="summaryProposal">
      <ul
        className="summaryProposal__valuesList"
        aria-label="Lista com principais valores da opção de financiamento"
      >
        {data.map(({ label, value, highlight, callerId }, index) => (
          <li
            key={index}
            className={`summaryProposal__valuesListItem ${
              highlight ? "summaryProposal__valuesListItem--highlight" : ""
            }`}
          >
            <Text as="p" className="summaryProposal__label">
              {label}
              <If
                condition={callerId}
                renderIf={
                  <button
                    type="button"
                    onClick={() => handleOpenInfo(callerId)}
                    className="amortizationCard__button amortizationCard__button--lifted"
                    aria-label="mais informações sobre o sistema de amortização"
                  >
                    <Icon
                      icon="informação"
                      className="amortizationCard__buttonIcon"
                      alt="Ícone de informação"
                      aria-hidden
                    />
                  </button>
                }
              />
            </Text>
            <Text as="p" className="summaryProposal__value">
              {value}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SummaryProposal
